import { GDPRSdk } from "@ciaopeople/cp-shatsu/GDPR";
import { ExternallyPassedContentAdData } from "../../../ads/adcall/composable/ContentSpecificAdCallFilter.js";
import { AudicomConfig } from "../AudicomPairingPing.js";
import { ComScoreConfig, ComScoreStreamingTagFactory } from "./ComScoreStreamingTag.js";
import { ComScoreStreamingTagFactoryImpl } from "./ComScoreStreamingTagImpl.js";


export function getComScoreStreamingTagFactory(cfg: ComScoreConfig, gdprPromise: Promise<GDPRSdk>, window: Window, extData?: ExternallyPassedContentAdData, audicom?: AudicomConfig): ComScoreStreamingTagFactory {

    return new ComScoreStreamingTagFactoryImpl(cfg,gdprPromise,window,extData, audicom);
}